import React, { useState } from "react";
import {
  View,
  Text,
  StyleSheet,
  TouchableOpacity,
  Linking,
  Alert,
  TouchableNativeFeedback,
  ImageBackground,
} from "react-native";
import Share from "react-native-share";
import dayjs from "dayjs";
import { useNavigation } from "@react-navigation/native";
import FastImage from "react-native-fast-image";
import { Grayscale } from "react-native-color-matrix-image-filters";

import analytics from "@services/analytics";
import { MY_SHOP } from "@constants/analyticsEventsCT";
import t from "@constants/localization";
import colors from "@constants/color";
// import OrderDetailsModal from "@screens/ClTasks/OrderDetailsModal";
import ChevronRight from "@assets/svg/ChevronRight";
import Coupon from "@assets/images/coupon.png";
import ConnectedByCM from "./ConnectedByCM";

const PATH = "WhatsAppMsgAlert";
const PATH2 = "screens/Shop/components/UpdatesCard";
const today = dayjs();
const yesterday = dayjs().subtract(1, "day");

const getCreatedAt = (time) => {
  let createdAt = "";
  if (dayjs(time).isSame(today, "day")) {
    createdAt = dayjs(time).format("hh:mm A");
  } else if (dayjs(time).isSame(yesterday, "day")) {
    createdAt = "Yesterday";
  } else {
    createdAt = dayjs(time).format("dddd");
  }
  return createdAt;
};

const calculateTimeText = (time) => {
  const Today = new Date();
  const expire = new Date(time);
  let diffInMs = Math.abs(expire - Today);
  if (diffInMs != NaN) {
    const constDiff = diffInMs;
    diffInMs %= 1000 * 60 * 60 * 24;
    const hr = diffInMs / (1000 * 60 * 60);
    diffInMs %= 1000 * 60 * 60;
    const min = diffInMs / (1000 * 60);
    diffInMs %= 1000 * 60;
    const sec = diffInMs / 1000;
    const getProperTime = (t) => {
      if (t === NaN) return "";
      t = parseInt(t);
      if (parseInt(t / 10) == 0) return `0${t.toString()}`;
      return t.toString();
    };
    let ans = `${getProperTime(sec)}s`;
    if (parseInt(constDiff / (1000 * 60)) != 0) {
      ans = `${getProperTime(min)}min ${ans}`;
    }
    if (parseInt(constDiff / (1000 * 60 * 60)) != 0) {
      ans = `${getProperTime(hr)}hr`;
    }
    return ans;
  }
  return "";
};

function UpdatesCard(props) {
  const navigation = useNavigation();
  const { item } = props;

  const greyScaled = item.valid === false;

  const [showCartItems, setShowCartItems] = useState(false);

  const onCardPress = () => {
    analytics.trackEvent(MY_SHOP.UPDATE_CLICKED, {
      update_id: item?._id,
      type: item?.type,
      user_id: item?.user_id,
      cx_type: item?.sub_type,
      last_order_recency: item?.last_order_recency,
      order_cancelled: item?.valid,
      screen: "My Shop",
    });
    navigation.navigate(item?.navigationParams?.screen, {
      screen: "My Shop",
      ...item?.navigationParams?.params,
    });
  };

  const onCTAPress = async (cta) => {
    const { isInstalled: haveWhatsApp } =
      await Share.isPackageInstalled("com.whatsapp");
    analytics.trackEvent(MY_SHOP.CTA_CLICKED, {
      cta_type: cta.cta_type,
      screen_name: "My Shop",
      type: item?.type,
      cx_type: item?.sub_type,
    });
    if (cta?.cta_type === "whatsapp") {
      if (!haveWhatsApp) {
        Alert.alert(
          t(`${PATH}/title`),
          t(`${PATH}/message`),
          [{ text: t(`${PATH}/onCloseText`), onClose: () => {} }],
          { cancelable: true },
        );
      } else {
        Linking.openURL(cta?.cta_value);
      }
    } else {
      Linking.openURL(cta?.cta_value);
    }
  };

  const isLatest = dayjs().diff(dayjs(item?.created_ts), "minute") <= 120;
  return (
    <View
      style={[
        {
          backgroundColor: isLatest ? "rgba(0, 171, 89, 0.1)" : "transparent",
          position: "relative",
        },
        styles.root,
      ]}
    >
      <TouchableNativeFeedback
        onPress={onCardPress}
        background={TouchableNativeFeedback.Ripple("rgba(0, 0, 0, 0.05)")}
      >
        <View style={styles.container}>
          <IsCxNew show={item?.ordered_with_current_cl === "false"} />
          <View style={styles.imageContainer}>
            <Image
              source={{ uri: item?.backgroundImage?.url }}
              resizeMode={FastImage.resizeMode.contain}
              style={styles.image}
              greyScaled={greyScaled}
            />
          </View>
          <View style={styles.descContainer}>
            <View style={styles.topDescContainer}>
              {item?.bottomLeftLabel?.is_connected_by_cm && (
                <ConnectedByCM
                  show={item?.bottomLeftLabel?.is_connected_by_cm}
                />
              )}
              <FirstOrder
                greyScaled={greyScaled}
                isFirstOrder={item?.bottomLeftLabel?.isFirstOrder}
              />
            </View>
            <View style={styles.headingContainer}>
              {greyScaled && item?.expires_at ? (
                <Text
                  style={styles.headingText}
                >{`${item?.user_name} जी का कैशबैक आज खत्म हो चुका है|`}</Text>
              ) : (
                <Text style={styles.headingText}>{item?.title}</Text>
              )}
            </View>
            {item?.coupon && (
              <ImageBackground
                source={Coupon}
                resizeMode="stretch"
                style={[styles.couponBackground, { borderWidth: 0 }]}
              >
                <Image
                  source={{
                    uri: "https://public-cdn.citymall.live/cm-admin-storage-public/1664252004516-coupon-icon.png",
                  }}
                  style={styles.couponImg}
                  greyScaled={greyScaled}
                />
                <View>
                  <Text style={styles.couponTitle}>
                    {item?.coupon?.title} | {item?.coupon?.coupon}
                  </Text>
                  {item?.coupon?.coupon_description && (
                    <Text style={styles.couponCondition}>
                      {item?.coupon?.coupon_description}{" "}
                    </Text>
                  )}
                  {/* <Text
                    style={{
                      fontSize: 12,
                      fontFamily: "NotoSansDevanagari-Bold",
                      lineHeight: 18,
                      color: colors.plain_green,
                    }}>
                    कूपन लगा लिया{" "}
                  </Text> */}
                </View>
              </ImageBackground>
            )}
            {item?.next_cb_expiry && (
              <View resizeMode="contain" style={styles.walletBackground}>
                <Image
                  source={{
                    uri: "https://public-cdn.citymall.live/cm-admin-storage-public/1664252155374-wallet-icon-details.png",
                  }}
                  style={styles.couponImg}
                  greyScaled={greyScaled}
                />
                <View>
                  <Text style={styles.walletTitle}>
                    {t(`${PATH2}/walletCashback`)}
                    <Text style={styles.walletBalance}>
                      ₹{parseInt(item?.next_cb_expiry?.balance)}
                    </Text>
                  </Text>
                  <ExpiresIn
                    {...{
                      expires_at: item?.next_cb_expiry?.expires_at,
                      greyScaled,
                    }}
                  />
                </View>
              </View>
            )}
            <View style={styles.infoContainer}>
              {item?.infoContainer?.map((info) => (
                <View style={styles.orderAmountContainer} key={info?.text}>
                  {info?.value ? (
                    <Text style={styles.descText}>
                      {info?.text}
                      <Text
                        style={[
                          styles.amountText,
                          { color: greyScaled ? "grey" : info?.valueColor },
                        ]}
                      >{`${info?.value}`}</Text>
                    </Text>
                  ) : (
                    <Text
                      style={[
                        styles.descText,
                        { fontFamily: "NotoSansDevanagari-Regular" },
                      ]}
                    >
                      {info?.text}
                    </Text>
                  )}
                </View>
              ))}
              {greyScaled && (
                <View style={styles.cancelledTag}>
                  <Text style={styles.cancelled}>
                    {item?.expires_at
                      ? t(`${PATH2}/expired`)
                      : t(`${PATH2}/cancelled`)}
                  </Text>
                </View>
              )}
            </View>
            <ExpiresIn
              {...{
                expires_at: item?.expires_at,
                greyScaled,
              }}
            />
            {showLimitedImages(
              item?.orderItemImages,
              3,
              greyScaled,
              setShowCartItems,
            )}
            <View style={styles.CTAContainer}>
              <Text style={styles.createdAtText}>
                {getCreatedAt(item?.created_ts)}
              </Text>
              {item?.buttonGroup && !greyScaled && (
                <View
                  style={{
                    flexDirection:
                      item?.buttonGroup?.ctaList?.length > 1 ? "column" : "row",
                    alignItems:
                      item?.buttonGroup?.ctaList?.length > 1
                        ? "flex-end"
                        : "center",
                  }}
                >
                  <Text style={styles.CTAText}>
                    {item?.buttonGroup?.cta_text}
                  </Text>
                  <View style={styles.CTAListContainer}>
                    {item.buttonGroup.ctaList.map((cta) => (
                      <TouchableOpacity onPress={() => onCTAPress(cta)}>
                        <Image
                          source={{ uri: cta?.labelIcon }}
                          resizeMode="contain"
                          style={styles.CTAImg}
                          greyScaled={greyScaled}
                        />
                      </TouchableOpacity>
                    ))}
                  </View>
                </View>
              )}
            </View>
          </View>
          {/* <OrderDetailsModal
            visible={showCartItems}
            setVisible={() => setShowCartItems(false)}
            data={item?.cart}
            user_name={item?.user_name}
          /> */}
        </View>
      </TouchableNativeFeedback>
    </View>
  );
}

function FirstOrder({ isFirstOrder, greyScaled }) {
  if (isFirstOrder) {
    return (
      <View style={styles.firstOrderContainer}>
        <Text
          style={[
            styles.firstOrderText,
            {
              color: greyScaled ? colors.lightBlack : colors.plain_green,
            },
          ]}
        >
          {t(`${PATH2}/firstOrder`)}
        </Text>
      </View>
    );
  }
  return null;
}

export const showLimitedImages = (
  imgs = [],
  limit = 4,
  greyScaled,
  setShowCartItems,
) => {
  if (!imgs.length || limit <= 0) return;
  const totalImages = imgs.length;
  const toShowOnlyArr = imgs.slice(0, limit);
  return (
    <TouchableOpacity
      onPress={() => setShowCartItems(true)}
      activeOpacity={0.6}
      style={{ alignItems: "center", flexDirection: "row", marginVertical: 4 }}
    >
      {toShowOnlyArr.map((imageUrl, imageIndex) => (
        <Image
          key={imageIndex}
          source={{ uri: imageUrl }}
          style={styles.itemImage}
          greyScaled={greyScaled}
        />
      ))}
      {toShowOnlyArr.length < totalImages && (
        <View style={styles.nMoreBox}>
          <Text style={{ color: colors.lightBlack }}>
            {t(`${PATH2}/items`, { count: +totalImages - limit })}
          </Text>
        </View>
      )}
      <View style={styles.icon}>
        <ChevronRight pathFill={colors.primary} />
      </View>
    </TouchableOpacity>
  );
};

function Image(props) {
  if (props.greyScaled) {
    return (
      <Grayscale>
        <FastImage {...props} />
      </Grayscale>
    );
  } else {
    return <FastImage {...props} />;
  }
}

function ExpiresIn({ expires_at, greyScaled }) {
  if (greyScaled || expires_at == null) return null;
  return (
    <View>
      <Text style={styles.expiresInText}>
        {t(`${PATH2}/expires`)}
        <Text style={styles.expiresInTime}>
          {calculateTimeText(expires_at)}
        </Text>
      </Text>
    </View>
  );
}

function IsCxNew({ show }) {
  if (show) {
    return (
      <View style={styles.is_cx_new_view}>
        <Text style={styles.is_cx_new_text}>नया</Text>
      </View>
    );
  } else return <></>;
}

const styles = StyleSheet.create({
  is_cx_new_view: {
    top: 4,
    left: -14,
    paddingHorizontal: 18,
    backgroundColor: "#00BA6E",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    transform: [{ rotate: "-45deg" }],
  },
  is_cx_new_text: {
    color: "white",
    fontWeight: "bold",
    fontSize: 11,
    lineHeight: 16,
  },
  root: {
    paddingHorizontal: 16,
    paddingBottom: 16,
  },
  container: {
    backgroundColor: "#ffffff",
    padding: 16,
    borderRadius: 10,
    elevation: 6,
    overflow: "hidden",
    shadowColor: colors.lightMediumBlack,
    flexDirection: "row",
  },
  headingContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  headingText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontWeight: "600",
    fontSize: 16,
    lineHeight: 24,
    width: "95%",
    textAlign: "left",
    color: colors.mediumBlack,
  },
  descContainer: {
    justifyContent: "space-between",
    flex: 1,
  },
  descText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 14,
    fontWeight: "400",
    lineHeight: 20,
    color: "rgba(0, 0, 0, 0.56)",
    textAlign: "left",
  },
  amountText: { color: "#00AB59", fontFamily: "NotoSansDevanagari-Bold" },
  orderAmountContainer: {
    flexDirection: "row",
    paddingVertical: 4,
  },
  CTAContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    // alignItems: "center",
    flex: 1,
  },
  imageContainer: {
    paddingVertical: 4,
    marginRight: 16,
  },
  image: {
    zIndex: 1000,
    height: 40,
    width: 40,
    margin: 8,
  },
  createdAtText: {
    fontFamily: "NotoSansDevanagari-Regular",
    fontSize: 12,
    fontWeight: "400",
    lineHeight: 24,
    textAlign: "left",
    color: colors.lightBlack,
  },
  CTAText: {
    fontFamily: "NotoSansDevanagari-SemiBold",
    fontSize: 14,
    fontWeight: "600",
    textAlign: "left",
    color: colors.mediumBlack,
  },
  firstOrderContainer: {
    flexDirection: "row",
    alignItems: "center",
    borderRadius: 20,
    borderWidth: 1,
    borderColor: colors.lighterBlack,
    width: 75,
    padding: 2,
    justifyContent: "center",
    marginVertical: 4,
  },
  firstOrderText: {
    fontFamily: "NotoSansDevanagari-Bold",
    fontSize: 11,
    fontWeight: "700",
    textAlign: "left",
    color: colors.plain_green,
    marginHorizontal: 2,
  },
  cancelledTag: {
    backgroundColor: colors.plain_red,
    borderRadius: 16,
    alignItems: "center",
    justifyContent: "center",
    paddingHorizontal: 8,
    textAlign: "center",
    height: 20,
  },
  cancelled: {
    fontSize: 11,
    lineHeight: 18,
    color: colors.white,
    fontFamily: "NotoSansDevanagari-Bold",
  },
  icon: { height: 12, width: 12, marginLeft: 8 },
  nMoreBox: {
    height: 60,
    alignItems: "center",
    justifyContent: "center",
  },
  itemImage: {
    height: 48,
    width: 40,
    marginRight: 6,
  },
  topDescContainer: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
  },
  couponBackground: {
    flexDirection: "row",
    paddingVertical: 8,
    marginVertical: 4,
    alignItems: "center",
    width: "100%",
    overflow: "hidden",
  },
  couponImg: { height: 27, width: 29, marginHorizontal: 16 },
  couponTitle: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 18,
  },
  couponCondition: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Regular",
    lineHeight: 18,
    maxWidth: "85%",
  },
  walletBackground: {
    flexDirection: "row",
    paddingVertical: 8,
    alignItems: "center",
    width: "100%",
    backgroundColor: "rgba(192, 110, 53, 0.05)",
    borderRadius: 10,
    marginVertical: 4,
  },
  walletTitle: {
    fontSize: 14,
    fontFamily: "NotoSansDevanagari-Regular",
    lineHeight: 20,
    color: "rgba(0,0,0,0.56)",
  },
  walletBalance: {
    fontSize: 16,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 24,
    color: "rgba(0,0,0,0.86)",
  },
  infoContainer: { flexDirection: "row", justifyContent: "space-between" },
  CTAImg: { height: 26, width: 26, margin: 8 },
  CTAListContainer: { flexDirection: "row" },
  expiresInText: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Regular",
    lineHeight: 18,
    color: "rgba(0,0,0,0.56)",
  },
  expiresInTime: {
    fontSize: 12,
    fontFamily: "NotoSansDevanagari-Bold",
    lineHeight: 18,
    color: "red",
  },
});

export default UpdatesCard;
